type MergeObjectsFunction = (existing: any, incoming: any) => any;

export function mergeField<T>(_debugName: string | undefined = undefined) {
  return function (existing: T, incoming: T, { mergeObjects }: { mergeObjects: MergeObjectsFunction }): T[] {
    return mergeObjects(existing, incoming);
  };
}
